module.exports = "/shiftTasks/components/modals/viewTaskInstance-44c3b0.html";